import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Send from '@material-ui/icons/Send';
import ResendGochiDialog from '../molecules/ResendGochiDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  withState('openResendGochi', 'updateOpenResendGochi', false)
);

const button = enhance(
  ({
    classes,
    openResendGochi,
    updateOpenResendGochi,
    params,
    onClickAction
  }) => {
    const cancelAction = () => updateOpenResendGochi(false);
    const resendGochiAction = param => {
      updateOpenResendGochi(false);
      onClickAction(param);
    };
    return (
      <div>
        <Button color="primary" onClick={() => updateOpenResendGochi(true)}>
          <Send className={classes.leftIcon} />
          ごち再送信
        </Button>
        <ResendGochiDialog
          openResendGochi={openResendGochi}
          updateOpenResendGochi={updateOpenResendGochi}
          cancelAction={cancelAction}
          resendGochiAction={() => resendGochiAction(params)}
          target="メニュー"
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
